import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BuildiveLogo from './BuildiveLogo';
import { Sparkles, ArrowRight, CheckCircle2, Globe, Shield } from 'lucide-react';
import { TwitterXIcon, DribbbleIcon, LinkedInIcon, InstagramIcon, BehanceIcon } from './SocialIcons';
import './Footer.css';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 4000);
    }
  };

  return (
    <footer className="footer">
      <div className="page-container">
        
        {/* Top Newsletter & Curation Strip */}
        <div className="footer-newsletter-banner">
          <div className="newsletter-info">
            <span className="newsletter-eyebrow">
              <Sparkles size={13} /> CURATED DESIGN DISPATCH
            </span>
            <h3 className="newsletter-title">Fresh template drops & challenge briefs every Thursday.</h3>
            <p className="newsletter-desc">Join 45,000+ UI/UX designers, 3D artists, and art directors receiving our weekly creative digest.</p>
          </div>
          
          <form className="newsletter-form" onSubmit={handleSubscribe}>
            <div className="newsletter-input-group">
              <input
                type="email"
                placeholder="Enter your work email..."
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="newsletter-input"
              />
              <button type="submit" className="newsletter-btn tactile-btn">
                {subscribed ? (
                  <>
                    <CheckCircle2 size={15} /> Subscribed
                  </>
                ) : (
                  <>
                    Join Digest <ArrowRight size={15} />
                  </>
                )}
              </button>
            </div>
            {subscribed && (
              <span className="newsletter-success-note">You're on the VIP drop list! Check your inbox for your welcome pack.</span>
            )}
          </form>
        </div>

        {/* Main Footer Links Columns */}
        <div className="footer-links-grid">
          
          {/* Brand Col */}
          <div className="footer-col-brand">
            <BuildiveLogo size={28} />
            <p className="footer-brand-bio">
              The premier marketplace and competitive challenge arena for world-class visual designers, UI/UX engineers, and 3D artists.
            </p>
            <div className="footer-social-row">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="footer-social-btn" title="Twitter / X">
                <TwitterXIcon size={16} />
              </a>
              <a href="https://dribbble.com" target="_blank" rel="noopener noreferrer" className="footer-social-btn" title="Dribbble">
                <DribbbleIcon size={16} />
              </a>
              <a href="https://behance.net" target="_blank" rel="noopener noreferrer" className="footer-social-btn" title="Behance">
                <BehanceIcon size={16} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="footer-social-btn" title="Instagram">
                <InstagramIcon size={16} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="footer-social-btn" title="LinkedIn">
                <LinkedInIcon size={16} />
              </a>
            </div>
          </div>

          {/* Col 1: Marketplace */}
          <div className="footer-col">
            <h4 className="footer-col-title">Marketplace</h4>
            <ul className="footer-nav-list">
              <li><Link to="/browse?category=UI%2FUX%20Design">UI Kits & Design Systems</Link></li>
              <li><Link to="/browse?category=3D%20Assets">3D Models & Shaders</Link></li>
              <li><Link to="/browse?category=Branding">Brand Mockups & Identity</Link></li>
              <li><Link to="/browse?category=Social%20Media">Motion Graphics & Social Kits</Link></li>
              <li><Link to="/browse?price=free">Free Community Assets</Link></li>
            </ul>
          </div>

          {/* Col 2: Challenges */}
          <div className="footer-col">
            <h4 className="footer-col-title">Challenges & Sprints</h4>
            <ul className="footer-nav-list">
              <li><Link to="/competitions">Active Design Bounties</Link></li>
              <li><Link to="/competitions">24-Hour Blitz Sprints</Link></li>
              <li><Link to="/competitions">Monthly Championships</Link></li>
              <li><Link to="/competitions">Challenge Winners Hall of Fame</Link></li>
              <li><Link to="/community">Design Feedback & Jams</Link></li>
            </ul>
          </div>

          {/* Col 3: Creators */}
          <div className="footer-col">
            <h4 className="footer-col-title">For Creators</h4>
            <ul className="footer-nav-list">
              <li><Link to="/dashboard">Creator Studio</Link></li>
              <li><Link to="/dashboard/upload">Publish an Asset</Link></li>
              <li><Link to="/settings">Creator Verification</Link></li>
              <li><Link to="/dashboard">Earnings & Payouts</Link></li>
              <li><Link to="/library">Asset Vault</Link></li>
            </ul>
          </div>

          {/* Col 4: Platform */}
          <div className="footer-col">
            <h4 className="footer-col-title">Platform</h4>
            <ul className="footer-nav-list">
              <li><Link to="/about">About Buildive</Link></li>
              <li><Link to="/community">Community Guild</Link></li>
              <li><Link to="/about">Commercial Licensing</Link></li>
              <li><Link to="/about">Submission Guidelines</Link></li>
              <li><a href="mailto:support@buildive.com">Contact Support</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Legal & Status Strip */}
        <div className="footer-bottom-bar">
          <div className="footer-copyright">
            © {new Date().getFullYear()} Buildive Inc. Handcrafted for the global design community.
          </div>

          <div className="footer-legal-links">
            <Link to="/about">Privacy</Link>
            <span>·</span>
            <Link to="/about">Terms</Link>
            <span>·</span>
            <Link to="/about">Licenses</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
